var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticClass:"loader"},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"mt-3"},[_vm._v("We are downloading profile, it will take a couple of minutes. Please wait :)")])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-circles"},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])
}]

export { render, staticRenderFns }